(function () {
  'use strict';

  var messages = window.frontendMessages || {};
  var EU_ISO2 = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE',
    'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT',
    'RO', 'SK', 'SI', 'ES', 'SE'
  ];

  function showFieldError(field, message) {
    if (!field) return;
    if (window.showTextInputError) {
      window.showTextInputError(message, field);
      return;
    }
    field.setCustomValidity(message || 'Invalid field');
  }

  function hideFieldError(field) {
    if (!field) return;
    if (window.hideTextInputError) {
      window.hideTextInputError(field);
      return;
    }
    field.setCustomValidity('');
  }

  function getNavbarRegionText() {
    try {
      var labels = document.querySelectorAll('.component-navbar__region-label, .component-navbar__region-btn');
      var regionText = '';
      labels.forEach(function (btn) {
        if (regionText) return;
        if (!btn || !btn.textContent) return;
        var style = window.getComputedStyle(btn);
        if (style && style.display === 'none') return;
        regionText = btn.textContent.replace(/\s+/g, ' ').trim().toUpperCase();
      });
      return regionText;
    } catch (error) {
      return '';
    }
  }

  function getDefaultCountryIso2() {
    try {
      if (typeof window.getMarketCode === 'function') {
        var market = String(window.getMarketCode() || '').trim().toLowerCase();
        if (market === 'us') return 'US';
        if (market === 'uk') return 'GB';
        if (market === 'eu') return 'DE';
        if (market === 'sg') return 'SG';
      }
    } catch (error) {}

    try {
      var country = String((window.Shopify && window.Shopify.country) || '').trim().toUpperCase();
      if (country === 'US') return 'US';
      if (country === 'GB' || country === 'UK') return 'GB';
      if (country === 'SG') return 'SG';
      if (EU_ISO2.indexOf(country) !== -1) return country;
    } catch (error) {}

    var regionText = getNavbarRegionText();
    if (regionText === 'US') return 'US';
    if (regionText === 'UK') return 'GB';
    if (regionText === 'EU') return 'DE';
    if (regionText === 'SG') return 'SG';
    return 'US';
  }

  function getZipLabelText(iso2) {
    var code = String(iso2 || '').trim().toUpperCase();
    if (!code) return 'Zip Code';
    if (code === 'US') return 'Zip Code';
    if (code === 'GB') return 'Post Code';
    return 'Postal Code';
  }

  function updateZipLabel(zipInput, iso2) {
    if (!zipInput || !zipInput.closest) return;
    var zipWrap = zipInput.closest('.take-drive-form__zip');
    if (!zipWrap) return;
    var labelEl = zipWrap.querySelector('.component-text-input__label');
    if (!labelEl) return;

    var requiredEl = labelEl.querySelector('.component-text-input__required');
    labelEl.textContent = getZipLabelText(iso2);
    if (requiredEl) {
      labelEl.appendChild(requiredEl);
    }
  }

  function getCountryIso2(countrySelectorEl) {
    if (!countrySelectorEl) return '';

    var attrValue = String(countrySelectorEl.getAttribute('data-country-code') || '').trim().toUpperCase();
    if (attrValue) return attrValue;

    var hiddenInput = countrySelectorEl.querySelector('input[type="hidden"]');
    var hiddenValue = String(hiddenInput && hiddenInput.value || '').trim().toUpperCase();
    if (hiddenValue && hiddenValue.length <= 3) return hiddenValue;

    return '';
  }

  function setCountryIso2(countrySelectorEl, iso2) {
    if (!countrySelectorEl) return;
    var normalized = String(iso2 || '').trim().toUpperCase();
    if (normalized) {
      countrySelectorEl.setAttribute('data-country-code', normalized);
    } else {
      countrySelectorEl.removeAttribute('data-country-code');
    }
  }

  function validateEmail(field) {
    if (!field) return true;

    var emailValue = String(field.value || '').trim();
    if (!emailValue) {
      showFieldError(field, messages.fieldRequired);
      return false;
    }

    var isValidEmail = false;
    if (window.validator && typeof window.validator.isEmail === 'function') {
      isValidEmail = window.validator.isEmail(emailValue);
    } else {
      isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
    }

    if (isValidEmail && window.tldts && typeof window.tldts.parse === 'function') {
      try {
        var domain = emailValue.split('@')[1];
        if (domain) {
          var parsed = window.tldts.parse(domain);
          if (!parsed.domain || !parsed.publicSuffix || (!parsed.isIcann && !parsed.isPrivate)) {
            isValidEmail = false;
          }
        }
      } catch (error) {}
    }

    if (!isValidEmail) {
      showFieldError(field, messages.emailInvalid);
      return false;
    }

    hideFieldError(field);
    return true;
  }

  function validateZip(field, countrySelectorEl, options) {
    if (!field) return true;

    var allowBlank = !!(options && options.allowBlank);
    var zipValue = String(field.value || '').trim();
    if (!zipValue) {
      if (allowBlank) {
        hideFieldError(field);
        return true;
      }
      showFieldError(field, messages.fieldRequired);
      return false;
    }

    if (zipValue.length > 20) {
      showFieldError(field, messages.max20Characters);
      return false;
    }

    var iso2 = getCountryIso2(countrySelectorEl) || getDefaultCountryIso2();
    var isValid = true;

    if (window.validator && typeof window.validator.isPostalCode === 'function') {
      try {
        isValid = window.validator.isPostalCode(zipValue, iso2 || 'any');
      } catch (error) {
        try {
          isValid = window.validator.isPostalCode(zipValue, 'any');
        } catch (fallbackError) {
          isValid = true;
        }
      }
    }

    if (!isValid) {
      showFieldError(field, messages.invalidZipCode);
      return false;
    }

    hideFieldError(field);
    return true;
  }

  function isZipBackendError(message) {
    var text = String(message || '');
    var lowered = text.toLowerCase();
    return !!(
      text.indexOf('Invalid postal code') > -1 ||
      text.indexOf('Invalid ZIP code') > -1 ||
      text.indexOf('Please enter a valid ZIP') > -1 ||
      text.indexOf('Please enter a valid postal code') > -1 ||
      (lowered.indexOf('zip') > -1 && lowered.indexOf('postal code') > -1)
    );
  }

  function applyZipBackendError(message, zipInput) {
    if (!isZipBackendError(message)) return false;
    showFieldError(zipInput, message || messages.invalidZipCode);
    if (zipInput && typeof zipInput.scrollIntoView === 'function') {
      zipInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return true;
  }

  function shouldSkipBlurValidation(event) {
    var relatedTarget = event && event.relatedTarget;
    return !!(
      relatedTarget &&
      relatedTarget.closest &&
      (
        relatedTarget.closest('.component-text-input__clear-btn') ||
        relatedTarget.closest('.component-text-input__password-toggle') ||
        relatedTarget.closest('.component-text-input__password-icon')
      )
    );
  }

  function handleCountryChanged(countrySelectorEl, zipInput, iso2) {
    setCountryIso2(countrySelectorEl, iso2);
    updateZipLabel(zipInput, iso2 || getDefaultCountryIso2());

    if (zipInput && String(zipInput.value || '').trim()) {
      validateZip(zipInput, countrySelectorEl, { allowBlank: true });
    } else {
      hideFieldError(zipInput);
    }
  }

  function init(options) {
    var countrySelectorEl = options && options.countrySelectorEl;
    var zipInput = options && options.zipInput;
    var emailInput = options && options.emailInput;

    var initialIso2 = getCountryIso2(countrySelectorEl);
    var labelIso2 = initialIso2 || getDefaultCountryIso2();
    setCountryIso2(countrySelectorEl, initialIso2);
    updateZipLabel(zipInput, labelIso2);

    if (emailInput && emailInput.getAttribute('data-take-drive-us-email-bound') !== 'true') {
      emailInput.setAttribute('data-take-drive-us-email-bound', 'true');
      emailInput.addEventListener('input', function () {
        hideFieldError(emailInput);
      });
      emailInput.addEventListener('blur', function (event) {
        if (shouldSkipBlurValidation(event)) return;
        if (!String(emailInput.value || '').trim()) return;
        validateEmail(emailInput);
      });
    }

    if (zipInput && zipInput.getAttribute('data-take-drive-us-zip-bound') !== 'true') {
      zipInput.setAttribute('data-take-drive-us-zip-bound', 'true');
      zipInput.addEventListener('input', function () {
        hideFieldError(zipInput);
      });
      zipInput.addEventListener('blur', function (event) {
        if (shouldSkipBlurValidation(event)) return;
        if (!String(zipInput.value || '').trim()) return;
        validateZip(zipInput, countrySelectorEl, { allowBlank: true });
      });
    }
  }

  window.TakeDriveUsValidation = {
    init: init,
    validateEmail: validateEmail,
    validateZip: validateZip,
    handleCountryChanged: handleCountryChanged,
    isZipBackendError: isZipBackendError,
    applyZipBackendError: applyZipBackendError,
    getDefaultCountryIso2: getDefaultCountryIso2,
    getCountryIso2: getCountryIso2
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.TakeDriveUsValidation.init({
        countrySelectorEl: document.getElementById('takeDriveCountry'),
        zipInput: document.querySelector('#takeDriveFirstStepForm input[name="zipCode"]'),
        emailInput: document.querySelector('#takeDriveFirstStepForm input[name="email"]')
      });
    });
  } else {
    window.TakeDriveUsValidation.init({
      countrySelectorEl: document.getElementById('takeDriveCountry'),
      zipInput: document.querySelector('#takeDriveFirstStepForm input[name="zipCode"]'),
      emailInput: document.querySelector('#takeDriveFirstStepForm input[name="email"]')
    });
  }
}());
